





























































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { createStudent } from './student.api'

@Component
export default class StudentCreate extends ViewBase {
  @Prop({ type: Object, default: () => ({}) }) item!: object
  @Prop({ type: Boolean, default: true }) visible!: boolean
  @Prop({ type: Number, default: 0 }) classId!: number

  labelCol = { span: 24 }
  wrapperCol = { span: 24 }
  lang = {}
  isEdit = false
  school = ''
  form = {}
  svisible = false
  notAllow: boolean = false
  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  created() {
    this.school = JSON.parse(localStorage.school).school_key
    this.lang = this.i18n.vBinding
    this.form = this.$form.createForm(this)
    const lang: any = this.lang
    this.notAllow = false
  }

  @Watch('visible')
  watchVisible(visible: any) {
    this.svisible = visible
  }
  onCancel() {
    const form: any = this.form
    form.resetFields()
    this.$emit('onCancel')
  }
  handleSubmit(e: any) {
    e.preventDefault()
    const form: any = this.form
    const item: any = this.item
    form.validateFieldsAndScroll((err: any, vals: any) => {
      if (!err) {
        const pdata = {
          class_id: this.classId,
          stu_name: vals.name,
          stu_number: vals.number
        }
        this.onOk(pdata)
      }
    })
  }
  async onOk(pdata: any) {
    try {
      const res = await createStudent(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      const form: any = this.form
      form.resetFields()
      this.$emit('onOk')
    } catch (ex) {
      this.handleError(ex)
    }
  }
}
